import "./MachineAppDefinitionCard.css";

import $ from 'jQuery';
import { learnMoreModal } from '../../machine_app/components/machine_app_learn_more_modal';
import machine_app_implementation_loader from '../../machine_app/models/machine_app_implementation_loader';

/**
 * Creates a machine app definition card for the given machine app definition.
 *
 * @param {() => void} pOpenMachineApp A function to open the machine app view associated with this card.
 * @param {MachineAppLibraryManager} pLibraryManager The machine app library manager.
 * @param {MachineAppImplementation} pDefinition The machine app definition to create a card for.
 * @returns {jQuery} The newly created machine app definition card.
 */
export function MachineAppDefinitionCard(pOpenMachineApp, pLibraryManager, pDefinition) {
  const lOptionalUiHooks = machine_app_implementation_loader.instance.getOptionalUiHooks(pDefinition.getType());
  const lFlavorText = machine_app_implementation_loader.instance.getFlavorText(pDefinition.getType());
  const lMachineAppType = pDefinition.getType();
  const lMachineAppLibrary = pLibraryManager.getLibraryByType(lMachineAppType);
  const lHasStartedSetup = lMachineAppLibrary.listMachineParameters().length !== 0;
  const lMachineAppList = lMachineAppLibrary.listApplications();

  const lCard = $('<div>').addClass('ml_application_landing_page_machine_app_card');
  const lCardBody = $('<div>').addClass('ml_application_landing_page_machine_app_card_body');

  const lTitle = $('<label>')
    .addClass('ml_application_landing_page_machine_app_card_title')
    .text(pDefinition.getName());

  const lStartButton = $('<button>')
    .addClass('ml_application_landing_page_machine_app_card_edit_button')
    .addClass('ml_application_landing_page_machine_app_card_edit_button_start')
    .text('Start')
    .on('click', pOpenMachineApp);

  const lThumbnail = $('<div>')
    .addClass('ml_application_landing_page_machine_app_card_thumbnail')
    .append(lOptionalUiHooks.getThumbnail && lOptionalUiHooks.getThumbnail());

  const lDescription = $('<p>')
    .addClass('ml_application_landing_page_machine_app_card_description')
    .text(lFlavorText.learnMoreModal.description);

  const lLearnMoreButton = $('<button>')
    .addClass('ml_application_landing_page_machine_app_card_button_learn_more')
    .append(
      $('<label>')
        .text('Learn more')
        .addClass('ml_application_landing_page_machine_app_card_button_learn_more_text'),
      $('<div>')
        .addClass('icon-back')
        .addClass('ml_application_landing_page_machine_app_card_button_learn_more_icon')
    )
    .on('click', () => {
      learnMoreModal(pOpenMachineApp, pDefinition, lHasStartedSetup);
    });

  lCardBody.append(
    lDescription,
    lLearnMoreButton,
  );

  if (lHasStartedSetup) {
    lStartButton
      .removeClass('ml_application_landing_page_machine_app_card_edit_button_start')
      .addClass('ml_application_landing_page_machine_app_card_edit_button_view_all');

    if (lMachineAppList.length === 0) {
      lStartButton.text('Continue Setup');
    }
    else {
      // Note: We show either apps that have errors or the last two created apps.
      const lAppsWithMostRecentlyCreatedFirst = [...lMachineAppList].reverse();
      const lAppsWithErrorInstancesFirst = lAppsWithMostRecentlyCreatedFirst.sort((pFirst, pSecond) => {
        const lFirstIsInvalid = !pFirst.getInjectableApplication().validate();
        const lSecondIsInvalid = !pSecond.getInjectableApplication().validate();
        if (lFirstIsInvalid) return -1;
        else if (lSecondIsInvalid) return 1;
        else return 0;
      });

      const lPreviewApps = lAppsWithErrorInstancesFirst.slice(0, 2);
      lCardBody.empty();
      lPreviewApps.forEach((pApp) => {
        const lHasWarnings = !pApp.getInjectableApplication().validate();
        const lIcon = $('<div>')
          .addClass('icon-machine-app')
          .addClass('ml_application_landing_page_machine_app_card_app_item_container_icon');
        const lAppListItem = $('<div>')
          .addClass('ml_application_landing_page_machine_app_card_app_item_container')
          .append(
            lIcon,
            $('<div>')
              .text(pApp.getName())
              .addClass('ml_application_landing_page_machine_app_card_app_item_container_text')
          )
          .on('click', pOpenMachineApp);

        if (lHasWarnings) {
          lIcon.append($('<span>').addClass("ml_validator_badge_ml").append(
            $('<span>').addClass("fas fa-exclamation").addClass('ml_validator_badge_exclamation_white')
          ));
        }

        lCardBody.append(lAppListItem);
        lStartButton.text('View All');
      });
    }
  }

  return lCard.append(
    lThumbnail,
    lTitle,
    lCardBody,
    lStartButton,
  );
}
